/* unplugin-vue-components disabled */import { render } from "./tasks.vue?vue&type=template&id=057c425a&scoped=true"
import script from "./tasks.vue?vue&type=script&lang=js"
export * from "./tasks.vue?vue&type=script&lang=js"

import "./tasks.vue?vue&type=style&index=0&id=057c425a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057c425a"],['__file',"src/pages/tenants/user/tasks/tasks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "057c425a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('057c425a', __exports__)) {
    api.reload('057c425a', __exports__)
  }
  
  module.hot.accept("./tasks.vue?vue&type=template&id=057c425a&scoped=true", () => {
    api.rerender('057c425a', render)
  })

}


export default __exports__